import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-indicador-circular-paginacao',
  templateUrl: './indicador-circular-paginacao.component.html',
  styleUrls: ['./indicador-circular-paginacao.component.scss']
})
export class IndicadorCircularPaginacaoComponent {
  @Input() quantidadeDePaginas: number;
  @Input() paginaAtiva: number;
  gerarArray() {
    return new Array(this.quantidadeDePaginas);
  }
}
